import { render, staticRenderFns } from "./ApprovalForm.vue?vue&type=template&id=d716c4e2&scoped=true&"
import script from "./ApprovalForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalForm.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalForm.vue?vue&type=style&index=0&id=d716c4e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d716c4e2",
  null
  
)

export default component.exports